import {ComponentStyleConfig} from "@chakra-ui/react";

const PanelContent:ComponentStyleConfig = {
  baseStyle: {
    ms: "auto",
    me: "auto",
    ps: "15px",
    pe: "15px",
  },
};

export const PanelContentComponent:any = {
  components: {
    PanelContent,
  },
};
